// extracted by mini-css-extract-plugin
export default {"cls1":"GroupCsvInstructions-Header_cls1__PtUrA","cls2":"GroupCsvInstructions-Header_cls2__YOu2P GroupCsvInstructions-Header_cls1__PtUrA"};